module.exports = __webpack_public_path__ + "img/sdg_en_(8).9aecd6ed.png";